// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"bottomButton_submitButton__X_-KY","safeArea":"bottomButton_safeArea__1wips"};